import { useAuthorizationExcelWriter } from '#authorization/excelserializer'
import { AuthorizationPatch } from '#authorization/model'
import { useDetailsExcelWriter } from '#details/excelserializer'
import { DetailsPatch } from '#details/model'
import { usePhotographsExcelWriter } from '#photographs/excelserializer'
import { PhotographsPatch } from '#photographs/model'
import { ExcelRecordWriter, ExcelRecordWriterProps, useGenericExcelSerializer } from '#record/excelserializer'
import React from 'react'
import { BaseComboPatch } from './mode'
import { SearchStateContext } from '#search/context'


export const useBaseComboExcelSerializer = () => useGenericExcelSerializer(useBaseComboExcelWriter())

export const useBaseComboExcelWriter = () => {
    const context = React.useContext(SearchStateContext)

    const scope = context.get().query?.scope ?? 'rav'

    const serializeDetails = useDetailsExcelWriter()
    const serializeAuthz = useAuthorizationExcelWriter()
    const serializePhotos = usePhotographsExcelWriter()

    const writer: ExcelRecordWriter<BaseComboPatch> = (props) => {


        serializeDetails(props as unknown as ExcelRecordWriterProps<DetailsPatch> )
        scope !== 'external' && serializeAuthz(props as unknown as ExcelRecordWriterProps<AuthorizationPatch>)
        serializePhotos(props as unknown as ExcelRecordWriterProps<PhotographsPatch>)
        
    }


    return writer
}